var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpainFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.217,
    height: 22.64,
    viewBox: "0 0 35.217 22.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_465",
    "data-name": "Rect\\xE1ngulo 465",
    width: 35.217,
    height: 22.64,
    rx: 5,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_17",
    "data-name": "Enmascarar grupo 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_977",
    "data-name": "Grupo 977",
    transform: "translate(0.167 -0.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_462",
    "data-name": "Rect\\xE1ngulo 462",
    width: 35.186,
    height: 23.457,
    transform: "translate(0 0)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_463",
    "data-name": "Rect\\xE1ngulo 463",
    width: 35.186,
    height: 7.819,
    transform: "translate(0 0)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_464",
    "data-name": "Rect\\xE1ngulo 464",
    width: 35.186,
    height: 7.819,
    transform: "translate(0 15.638)",
    fill: "#d80027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpainFlag);
export default __webpack_public_path__ + "static/media/spain-flag.c1962b9ad1e2eb0aaaf5b3f071692fea.svg";
export { ForwardRef as ReactComponent };